/**
 * sessionStorage flag set when the user has just completed an Auth0
 * redirect round-trip (login/callback).
 *
 * It allows the app to distinguish "just came back from Auth0" from
 * "the user refreshed the page", so a forced token renewal can be
 * triggered on refresh without creating redirect loops.
 */
export const AUTH_REDIRECT_COMPLETED_FLAG = 'dynoweb:auth-completed';
